import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  // 公共属性
  state: {
    username: '',
    password: '',
    instrumentAll: [],
    lotNumberAll: [],
    testNameAll: [],
  },
  getters: {
  },
  mutations: {
    setUserName(state, username) {
      state.username =  username
    },
    setPassWord(state, password) {
      state.password =  password
    },
    setInstrumentAll(state, instrumentAll) {
      state.instrumentAll =  instrumentAll
    },
    setLotNumberAll(state, lotNumberAll) {
      state.lotNumberAll =  lotNumberAll
    },
    setTestNameAll(state, testNameAll) {
      state.testNameAll =  testNameAll
    },
  },
  actions: {
  },
  modules: {
  }
})
